import React from 'react'
import { Row, Col } from 'antd'
import AddFaq from 'components/shared/AddFaq'
import ArticleList from 'components/shared/ArticleList'
import PropTypes from 'prop-types'
import Description from './description'
import Heading from './heading'

export default function TermsContent({ term }) {
  const {
    attributes: {
      articles: { data: articles },
    },
  } = term

  const input = {
    article_type: 'faq',
    financial_term: term.id,
  }
  return (
    <Row className="page-wrapper page">
      <Col span={24}>
        <Heading term={term} />
        <Description term={term} />
        {/* FAQ Goes here */}
      </Col>
      <Col xs={24} md={16}>
        <Row className="row-wrapper">
          <AddFaq input={input} />
        </Row>
        <Row className="row-wrapper">
          <ArticleList articles={articles} />
        </Row>
      </Col>
    </Row>
  )
}

TermsContent.propTypes = {
  term: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
}
